<h1 mat-dialog-title>
  Redigere importfeltinformasjon for {{importField.field_title}}
</h1>

@if (importFieldSet) {
  <div mat-dialog-content [formGroup]="formGroup">
    <div>
      @for (mapField of importField.field_map; track $index) {
        <ng-container>
          <app-column-select
            [mapField]="mapField"
            [formGroup]="formGroup"
          ></app-column-select>
        </ng-container>
      }
    </div>

    <div>
      @if (importField.field_options.length === 1) {
        <p>
          Dette feltet krever en forhåndssatt verdi:
        </p>
      }

      @else if (importField.field_options.length > 1) {
        <p>
          Dette feltet krever forhåndssatte verdier:
        </p>
      }

      @if (importField.description) {
        <p>
          {{importField.description}}
        </p>
      }

      @for (fieldOption of importField.field_options; track $index) {
        <ng-container>
          <app-concept-select [fieldOption]="fieldOption" [formGroup]="formGroup"></app-concept-select>
        </ng-container>
      }
    </div>

  </div>
}

<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">
    Avbryt
  </button>

  <button mat-button (click)="close()" [disabled]="isInvalid()">
    Ok
  </button>
</div>
